// ==================== LOGO COMPONENT ====================

import { cn } from '../../utils/helpers';
import logoDark from '../../assets/amplifymsg_logo_dark_transparent.png';
import logoLight from '../../assets/amplifymsg_logo_light_transparent.png';

export interface LogoProps {
  variant?: 'dark' | 'light';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const Logo = ({
  variant = 'dark',
  size = 'md',
  className,
}: LogoProps) => {
  // Logo heights - the logo image already contains the brand name
  const sizes = {
    sm: 'h-14',
    md: 'h-16',
    lg: 'h-24',
    xl: 'h-32',
  };

  const logoSrc = variant === 'dark' ? logoDark : logoLight;

  return (
    <div className={cn('flex items-center', className)}>
      <img
        src={logoSrc}
        alt="AmplifyMsg"
        className={cn(sizes[size], 'w-auto object-contain')}
      />
    </div>
  );
};

// Icon-only version (for collapsed sidebar, etc.)
const LogoIcon = ({
  size = 'md',
  className,
}: {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}) => {
  const sizes = {
    sm: 'w-10 h-10',
    md: 'w-12 h-12',
    lg: 'w-14 h-14',
    xl: 'w-16 h-16',
  };

  const textSizes = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl',
    xl: 'text-3xl',
  };

  return (
    <div className={cn(
      'flex items-center justify-center rounded-xl bg-linear-to-br from-(--color-signal-orange) to-(--color-warm-amber) shadow-orange',
      sizes[size],
      className
    )}>
      <span className={cn('text-white font-heading font-bold', textSizes[size])}>A</span>
    </div>
  );
};

export { Logo, LogoIcon };

